const StringUtil = {
  /**
   * https://locutus.io/php/url/rawurldecode/
   *
   * @param str
   * @returns {string}
   */
  rawurldecode(str) {
    return decodeURIComponent((str + '')
      .replace(/%(?![\da-f]{2})/gi, function () {
        // PHP tolerates poorly formed escape sequences
        return '%25'
      }));
  },
  cleanAddress(addressString) {
    return addressString.replace(/^\|+|\|+$/g, '');
  },
  parseAddress(addressString) {
    return addressString.split('|');
  },
}

export default StringUtil;
